const ja = {
  // Home
  'home.companyName': 'OUR ENGINEERING',
  'home.support': 'サポート',
  'home.privacy': 'プライバシーポリシー',
  'home.term': '利用規約',

  // Support
  'support.title': 'サポート',
  'support.intro': 'OUR ENGINEERING のサービスをご利用いただきありがとうございます。',
  'support.description': '日本を拠点とし、長田康介と後藤田千里が運営する当社は、ユーザーの皆さまにユニークでシームレスな体験を提供することに専念しています。',
  'support.contactTitle': 'お問い合わせ',
  'support.email': 'contact@ourengineeringstudio.com',
  'support.emailLabel': 'メール:',
  'support.responseTimeLabel': '返信時間:',
  'support.responseTime': '営業日（月〜金）に通常24〜48時間以内にご返信いたします。',
  'support.urgentLabel': '緊急のお問い合わせ:',
  'support.urgent': '件名に [URGENT] と記載してください。',
  'support.techTitle': 'テクニカルサポート',
  'support.techIntro': '問題を迅速に解決するため、以下の情報をお知らせください：',
  'support.techDevice': 'デバイスとOSのバージョン',
  'support.techDescription': '問題の詳細と再現手順',
  'support.techScreenshots': 'スクリーンショット（該当する場合）',

  // Privacy Policy
  'privacy.title': 'プライバシーポリシー',
  'privacy.lastUpdated': '最終更新日: 2026年3月9日',
  'privacy.intro': 'OUR ENGINEERING（以下「当社」）は、モバイルアプリケーションおよびウェブサービスを運営しています。本ポリシーは、個人データの収集、使用、および開示に関する当社の慣行をお知らせするものです。',
  'privacy.section1Title': '1. 情報の収集と利用',
  'privacy.section1Personal': 'お問い合わせの際に、お名前とメールアドレスを収集する場合があります。',
  'privacy.section1PersonalLabel': '個人情報:',
  'privacy.section1Usage': 'サービスの改善のため、デバイス情報、IPアドレス、利用状況を収集する場合があります。',
  'privacy.section1UsageLabel': '利用データ:',
  'privacy.section2Title': '2. 日本の法律への準拠',
  'privacy.section2Body': '当社は、日本の個人情報保護法（APPI）を遵守しています。',
  'privacy.section3Title': '3. グローバルなプライバシー権利',
  'privacy.section3GdprLabel': 'GDPR権利（EU居住者）:',
  'privacy.section3Gdpr': 'アクセス権、訂正権、消去権、およびデータポータビリティの権利。',
  'privacy.section3CcpaLabel': 'CCPA権利（カリフォルニア州居住者）:',
  'privacy.section3Ccpa': '個人情報の知る権利、削除する権利、および販売をオプトアウトする権利。',
  'privacy.section4Title': '4. データセキュリティ',
  'privacy.section4Body': '当社は適切なセキュリティ対策を実施していますが、インターネットを介した送信方法は100%安全ではないことをご了承ください。',
  'privacy.section5Title': '5. 児童のプライバシー',
  'privacy.section5Body': '当社のサービスは13歳未満の児童を対象としていません。児童の個人データを故意に収集することはありません。',
  'privacy.section6Title': '6. 準拠法',
  'privacy.section6Body': '本プライバシーポリシーは日本の法律に準拠します。',
  'privacy.contactTitle': 'お問い合わせ',

  // Term
  'term.title': '利用規約',
  'term.section1Title': '1. 利用規約の同意',
  'term.section1Body': 'OUR ENGINEERING が提供するアプリケーションおよびサービス（以下「本サービス」）にアクセスし利用することにより、お客様は本規約に拘束されることに同意したものとみなされます。',
  'term.section2Title': '2. プライバシーポリシーの参照',
  'term.section2Body': '本サービスのご利用は、当社のプライバシーポリシーにも準拠します。当社の慣行をご理解いただくため、注意深くご確認ください。',
  'term.section3Title': '3. ユーザーの責任',
  'term.section3Body': 'お客様は、本サービスを責任を持って利用することに同意し、違法な目的での使用や知的財産権の侵害を行ってはなりません。',
  'term.section4Title': '4. 保証の免責',
  'term.section4Body': '本サービスは「現状のまま」提供され、いかなる種類の保証もありません。本サービスが常に安全で、エラーがなく、中断なく機能することを保証するものではありません。',
  'term.section5Title': '5. 責任の制限',
  'term.section5Body': '法律で許容される最大限の範囲において、当社は、本サービスの使用または使用不能に起因する間接的、偶発的、または結果的な損害、またはデータや利益の損失について責任を負いません。',
  'term.section6Title': '6. 準拠法と管轄',
  'term.section6Body': '本規約は日本の法律に準拠します。紛争が生じた場合は、日本の裁判所が専属的管轄権を有します。',

  // Waitlist
  'waitlist.comingSoon': 'Coming Soon',
  'waitlist.emailPlaceholder': 'メールアドレスを入力',
  'waitlist.submit': 'ウェイトリストに登録',
  'waitlist.success': '登録しました！リリース時にお知らせします。',
  'waitlist.successTitle': '登録が完了しました！',
  'waitlist.successBody': 'アプリの準備ができ次第、お知らせします。お楽しみに！',
  'waitlist.backHome': 'ホームへ戻る',
  'waitlist.alreadyRegistered': 'このメールアドレスは登録済みです。',
  'waitlist.error': '登録に失敗しました。もう一度お試しください。',

  // Common
  'common.home': 'ホーム',
};

export default ja;
